import { Turnstile } from '@marsidev/react-turnstile'
import Input from 'components/Form/Input/Input'
import Lock from 'public/assets/lock.svg'
import { FieldValues, UseControllerProps, UseFormSetValue } from 'react-hook-form'
import { isTurnstileEnabled, turnstileSiteKey } from 'utils/turnstileHelper'
import styles from './TurnstileButton.module.scss'

type TurnstileProps = {
  token: string
}

type Props = UseControllerProps<FieldValues> & {
  setValue: UseFormSetValue<TurnstileProps>
  hasFailed: (b: boolean) => void
}

const TurnstileButton = ({ control, rules, setValue, hasFailed }: Props) => {
  if (!isTurnstileEnabled) return null

  return (
    <div className={styles.container}>
      <div className={styles['captcha-text']}>
        <Lock />
        <p className={styles.text}>Complete the CAPTCHA so we know you’re human before we send your message</p>
      </div>
      <Turnstile
        options={{
          //execution: 'execute',
          appearance: 'always',
          size: 'normal',
          theme: 'light',
        }}
        siteKey={turnstileSiteKey}
        onError={() => hasFailed(true)}
        onExpire={() => hasFailed(true)}
        onSuccess={(token) => setValue('token', token)}
      />
      <div className={styles.hidden}>
        <Input control={control} rules={rules} name='token' />
      </div>
    </div>
  )
}

export default TurnstileButton
